import { useTranslation } from 'react-i18next';
import type { ReportFormat } from '@/application/metrics';
import { ExportButtons } from './ExportButtons';

interface NoVolvieronExportControlsProps {
  canExport: boolean;
  empty: boolean;
  disabled?: boolean;
  emptyMessageKey?: string;
  onExport: (format: Extract<ReportFormat, 'xlsx' | 'csv'>) => Promise<void>;
}

/** CSV/Excel de recontacto. Oculto sin permiso; vacío no dispara descarga. */
export function NoVolvieronExportControls({
  canExport,
  empty,
  disabled,
  emptyMessageKey = 'metrics.noVolvieron.export.empty',
  onExport,
}: NoVolvieronExportControlsProps) {
  const { t } = useTranslation();
  if (!canExport) return null;
  if (empty) {
    return (
      <p className="text-sm text-slate-600 dark:text-slate-300" data-testid="no-volvieron-export-empty" role="status">
        {t(emptyMessageKey)}
      </p>
    );
  }
  return (
    <div data-testid="no-volvieron-export">
      <ExportButtons formats={['xlsx', 'csv']} onExport={onExport} disabled={disabled} compact />
    </div>
  );
}
